export default __webpack_public_path__ + "static/media/dashboard.189d2929.svg";